export const xhrDefaultMessage = 'Something went wrong,Try again...';

export const errorMessages = {
    phone: 'Phone number is invalid!',
    email: 'Email is invalid!',
    salaryRange: 'Salary range is invalid!',
    GPA: 'GPA is invalid! (it must be in 0.0 - 4.0 range)',
    zipCode: 'Zip code Is invalid!',
    dateRange: 'Date range is invallid!',
    input: 'Input value Is invalid!',
    birthDate: 'You should be at least 18 years old!',
    URL: 'Invalid url format'
};